import { completeOnboarding } from '../onboardingStorage';
import { getOnboardingLaunchConditions } from './getOnboardingLaunchConditions';
import { OnboardingLaunchConditions, UseOnboardingLaunchConditionsResult } from './types';
import { useEffect, useMemo, useRef, useState } from 'react';

export const ONBOARDING_LAUNCH_DELAY_MS = 800;

export const useOnboardingLaunchConditions = (
  conditions: OnboardingLaunchConditions,
  onShipmentDetected?: () => void
): UseOnboardingLaunchConditionsResult => {
  const result = useMemo(() => getOnboardingLaunchConditions(conditions), [conditions]);
  const completedForUserIdRef = useRef<string | null>(null);
  const [isDelayElapsed, setIsDelayElapsed] = useState(false);

  useEffect(() => {
    if (!result.shouldCompleteOnboarding) return;
    if (completedForUserIdRef.current === conditions.userId) return;

    completeOnboarding(conditions.userId);
    completedForUserIdRef.current = conditions.userId;
    onShipmentDetected?.();
  }, [conditions.userId, onShipmentDetected, result.shouldCompleteOnboarding]);

  useEffect(() => {
    setIsDelayElapsed(false);

    if (!result.isEligible) return;

    const timeoutId = window.setTimeout(() => {
      setIsDelayElapsed(true);
    }, ONBOARDING_LAUNCH_DELAY_MS);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [result.isEligible]);

  return {
    ...result,
    isLaunchReady: result.isEligible && isDelayElapsed
  };
};